module.exports = __webpack_public_path__ + "img/customer-icon-22.fc9ea157.png";